import React, { useRef, useState, useEffect } from "react";
import {
  getCountryList,
  updateActiveStatus,
} from "../../services/country.services";
import {
  CAvatar,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPencil, cilPlus } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import Switch from "react-switch";
import toast from "react-hot-toast";

const CountryManagementTable = () => {
  const toaster = useRef();
  // const [toast, addToast] = useState("");
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const defaultErrorMessage = "Something went wrong";
  useEffect(() => {
    getCountryItem(currentPage);
  }, []);

  const getCountryItem = (page) => {
    setIsLoading(true);
    getCountryList({ limit, page })
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getCountryItem(newPage);
  };

  const handleStatusChange = (checked, id) => {
    const data = {
      isActive: checked,
    };
    toast
      .promise(
        updateActiveStatus(data, id),
        {
          loading: "Loading",
          success: "Status updated Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        getCountryItem(currentPage);
      })
      .catch((error) => console.error(error));
  };

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Country Management
              </h4>
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              <div className="d-flex justify-content-end">
                <Link to="/create-bulk-country" style={{ marginRight: "10px" }}>
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Upload Country Data
                  </CButton>
                </Link>
                <Link to="/create-country">
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Create Country
                  </CButton>
                </Link>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">No.</CTableHeaderCell>
                <CTableHeaderCell>Name</CTableHeaderCell>
                <CTableHeaderCell>Code</CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Active Status
                </CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="5">Loading...</CTableDataCell>
                </CTableRow>
              ) : data?.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="5">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data?.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell className="text-center">
                      <div>{index + 1}</div>
                    </CTableDataCell>

                    <CTableDataCell className="text-capitalize">
                      <div>{item.name}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      <div>{item.code}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <Switch
                        onChange={(checked, id) =>
                          handleStatusChange(checked, item._id)
                        }
                        checked={item.isActive}
                      />
                    </CTableDataCell>
                    <CTableDataCell>
                      <Link to={`/edit-country/${item._id}`}>
                        <CButton color="secondary" style={{ color: "white" }}>
                          <FaEdit />
                        </CButton>
                      </Link>
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      {/* <DeleteModal
        visible={visibleDeleteModal}
        setVisibleDeleteModal={setVisibleDeleteModal}
        addToast={addToast}
      />
      <CToaster ref={toaster} push={toast} placement="top-end" /> */}
    </>
  );
};

export default CountryManagementTable;
